<template>
  <div style="max-width: 700px; margin: 20px auto; padding: 16px">
    <h2>Информация об автобусах</h2>

    <!-- Плашка с датой обновления — показывается всегда, если есть -->
    <div
      v-if="updatedAt"
      style="
        margin-bottom: 12px;
        padding: 8px 12px;
        background: #f1f5f9;
        border-radius: 6px;
        font-size: 14px;
        color: #334155;
      "
    >
      Последнее обновление:
      <b>{{ formatDate(updatedAt) }}</b>
      <span v-if="updatedBy" style="color: #64748b"> ({{ updatedBy }}) </span>
    </div>

    <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px">
      <button class="btn btn-primary btn-sm" @click="applyTemplate('allHere')">
        Все автобусы на месте
      </button>
      <button class="btn btn-secondary btn-sm" @click="applyTemplate('clear')">
        Очистить
      </button>
    </div>

    <textarea
      v-model="text"
      rows="8"
      class="form-control"
      placeholder="Введите информацию об автобусах..."
      style="width: 100%; min-height: 180px"
    ></textarea>

    <div
      style="
        margin-top: 12px;
        display: flex;
        gap: 12px;
        align-items: center;
        flex-wrap: wrap;
      "
    >
      <button
        class="btn btn-success"
        :disabled="saving || !isDirty"
        @click="save"
      >
        {{ saving ? "Сохранение..." : "Сохранить" }}
      </button>

      <span v-if="!isDirty && !saving" style="color: #64748b; font-size: 13px">
        Изменений нет
      </span>
      <span v-if="error" style="color: red; font-size: 13px">
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script>
import TutorialDataService from "../services/TutorialDataService";

const TEMPLATES = {
  allHere:
    "Все автобусы на месте.\n" +
    "Отправление по расписанию.\n" +
    "Задержек нет.",
  clear: "",
};

export default {
  data() {
    return {
      text: "",
      savedText: "", // для отслеживания "грязности"
      updatedAt: null, // дата последнего обновления с сервера
      updatedBy: "", // кто обновил
      saving: false,
      error: "",
    };
  },
  computed: {
    isDirty() {
      return this.text !== this.savedText;
    },
  },
  methods: {
    async load() {
      try {
        const res = await TutorialDataService.getBusInfo();
        const data = res.data || {};
        this.text = data.text || "";
        this.savedText = this.text;
        this.updatedAt = data.updatedAt || null;
        this.updatedBy = data.updatedBy || "";
      } catch (e) {
        console.log(e);
        this.error = "Не удалось загрузить данные";
      }
    },

    applyTemplate(name) {
      this.text = TEMPLATES[name] ?? "";
    },

    async save() {
      this.saving = true;
      this.error = "";
      try {
        const res = await TutorialDataService.updateBusInfo({
          text: this.text,
        });
        const data = res.data || {};
        this.text = data.text ?? this.text;
        this.savedText = this.text;
        // сервер возвращает свежий документ — берём updatedAt оттуда
        this.updatedAt = data.updatedAt || new Date().toISOString();
        this.updatedBy = data.updatedBy || this.updatedBy;
      } catch (e) {
        console.log(e);
        this.error = "Ошибка сохранения";
      } finally {
        this.saving = false;
      }
    },

    formatDate(value) {
      const d = new Date(value);
      if (isNaN(d.getTime())) return "—";

      // формат: 07.10.2026 14:35
      const pad = (n) => String(n).padStart(2, "0");
      return (
        `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      );
    },
  },
  mounted() {
    this.load();
  },
};
</script>
